import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import axios from "axios/index";
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import FuseTheme from "../global/theme";
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import ContentKey from 'material-ui/svg-icons/communication/vpn-key';

/**
 * A component for retrieving a transaction key for TSYS Gateway.
 *
 */
class GenerateTSYSTransactionKey extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disableButton: false,
            gateway: {},
            gatewayRecord: {},
            locationId: null,
            message: null,
            showComponent: true,
            showMessageChanged: false,
            showMessageError: false,
            submitting: false,
            transactionKey: null
        };

        this.compareGatewayValues = this.compareGatewayValues.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    componentWillMount() {
        // Show this component if TSYS credentials exist
        let gateway;
        let showComponent;
        if (this.props.view === 'edit' || this.props.view === 'create') {
            // Edit/Create: Set this component's Gateway data based on form record
            gateway = this.props.record.gateway_account;
            showComponent = this.checkForGateway(gateway);
            this.setState({
                gateway: gateway,
                gatewayRecord: gateway,
                locationId: this.props.record.id,
                showComponent: showComponent
            });
            this.props.dispatch(change('record-form', 'gateway_account_modified', false));
            this.props.dispatch(change('record-form', 'gateway_account_transaction_key', null));
        }
        if (this.props.view === 'show') {
            // Show: Set this component's Gateway data based on props
            gateway = this.props.gateway;
            showComponent = this.checkForGateway(gateway);
            if (gateway) {
                this.setState({
                    gateway: gateway,
                    gatewayRecord: gateway,
                    locationId: this.props.location,
                    showComponent: showComponent,
                    transactionKey: gateway.transaction_key
                });
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.view === 'edit' || this.props.view === 'create') {
            if (nextProps.gateway !== this.props.gateway) {
                // Edit/Create: Store the gateway values and compare
                this.setState({
                        gateway: nextProps.gateway
                    },
                    () => this.compareGatewayValues(nextProps.gateway)
                );
            }
        }
        if (this.props.view === 'show') {
            let showComponent = true;
            if (nextProps.gateway && nextProps.gateway.gateway !== 'TSYS') {
                // Show: If the Gateway is not TSYS, hide this component
                showComponent = false;
                this.setState({
                    showComponent: showComponent
                });
            } else {
                if (nextProps.gateway) {
                    // Show: Display component based on required values
                    if (
                        !nextProps.gateway.username || nextProps.gateway.username === '' ||
                        !nextProps.gateway.password || nextProps.gateway.password === '' ||
                        !nextProps.gateway.merchant_id || nextProps.gateway.merchant_id === '' ||
                        !nextProps.gateway.terminal_id || nextProps.gateway.terminal_id === '' ||
                        !nextProps.gateway.terminal_nr || nextProps.gateway.terminal_nr === ''
                    ) {
                        showComponent = false;
                    }
                    this.setState({
                        gateway: nextProps.gateway,
                        gatewayRecord: nextProps.gateway,
                        showComponent: showComponent,
                        transactionKey: nextProps.gateway.transaction_key
                    });
                }
            }
        }
    }

    /**
     * Determine component display by checking for missing values
     *
     * @param gateway
     * @return {boolean}
     */
    checkForGateway = (gateway) => {
        let show = true;
        if (!gateway ||
            !gateway.gateway ||
            gateway.gateway !== 'TSYS' ||
            !gateway.username || gateway.username === '' ||
            !gateway.password || gateway.password === '' ||
            !gateway.merchant_id || gateway.merchant_id === '' ||
            !gateway.terminal_id || gateway.terminal_id === '' ||
            !gateway.terminal_nr || gateway.terminal_nr === ''
        ) {
            show = false;
        }
        return show;
    };

    /**
     * Check if Gateway Account values have changed from the form's record (Create/Edit only)
     *
     * @param values
     */
    compareGatewayValues = (values) => {
        // If the Gateway credentials have changed from the stored record, disable this component
        const gatewayRecord = this.state.gatewayRecord;
        let changedFromRecord = false;
        if (
            values.username !== gatewayRecord.username ||
            values.password !== gatewayRecord.password ||
            values.merchant_id !== gatewayRecord.merchant_id ||
            values.terminal_id !== gatewayRecord.terminal_id
        ) {
            changedFromRecord = true;
            this.props.dispatch(change('record-form', 'gateway_account_transaction_key', null));
        }
        this.setState({
            disableButton: false,
            showComponent: !changedFromRecord,
            showMessageChanged: changedFromRecord,
            showMessageError: false
        });
        this.props.dispatch(change('record-form', 'gateway_account_modified', changedFromRecord));
    };

    // Handle click event to receive Transfer
    handleButtonClick = (e) => {
        this.setState({
            disableButton: true,
            showMessageError: false,
            submitting: true
        });
        this.fetchData();
    };

    // Post a request to receive this Transfer for the current Location
    fetchData() {

        const params = {
            location_id: this.state.locationId
        };

        // Assemble the URI
        const resource = locationResources.LocationTSYSTransactionKey.GET_ONE(params);
        let transactionKey = null;
        let message = null;

        // Post the data
        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        transactionKey = result.data.payload.transaction_key;
                        if (transactionKey) {
                            if (this.props.view === 'edit' || this.props.view === 'create') {
                                this.props.dispatch(change('record-form', 'gateway_account_transaction_key', transactionKey));
                                this.props.dispatch(change('record-form', 'gateway_account.transaction_key', transactionKey));
                            }
                            this.setState({
                                disableButton: true,
                                message: null,
                                showMessageError: false,
                                submitting: false,
                                transactionKey: transactionKey
                            });
                        }
                    }
                }).catch((error) => {
                    let response = '';
                    message = 'Sorry, a transaction key could not be generated.';
                    let reason = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(response);
                        if (error.response.data.error_message) {
                            response = error.response.data.error_message;
                            if (response.toLowerCase().indexOf('invalid') !== -1 && response.toLowerCase().indexOf('password') !== -1) {
                                reason = ' Invalid password.'
                            } else if (response.toLowerCase().indexOf('locked') !== -1) {
                                reason = ' User is locked.';
                            }
                            message += reason;
                            console.log('Error: ' + response.error_message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    this.setState({
                        disableButton: false,
                        message: message,
                        showMessageError: true,
                        submitting: false,
                        transactionKey: transactionKey
                    });
                });
            });
    }

    render() {
        const {
            disableButton,
            message,
            showComponent,
            showMessageChanged,
            showMessageError,
            submitting,
            transactionKey
        } = this.state;

        const styles = {
            container: {
                display: 'block',
                margin: '1em 0 1em 0',
                verticalAlign: 'top',
            },
            error: {
                color: FuseTheme.palette.accent1Color,
            },
            header: {
                display: 'block',
                fontSize: 16,
                fontWeight: 600,
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            key: {
                display: 'block',
                fontSize: 16,
                fontWeight: 400,
                margin: '0 0 1em 0',
            },
            label: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.disabledColor,
                margin: '1em 0 0 0',
            },
            loader: {
                display: 'inline-block',
                margin: '0 0 0 8px',
                verticalAlign: 'middle',
            },
            message: {
                display: 'block',
                width: '100%',
                fontSize: 14,
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
        };
        return (
            <div>
                {this.props.view === 'show' &&
                <div>
                    <div style={styles.label}>Transaction Key</div>
                    <div style={styles.key}>{transactionKey}</div>
                </div>
                }
                {showComponent &&
                <div style={styles.container}>
                    <span style={styles.header}>
                        Generate a TSYS Transaction Key
                    </span>
                    <span style={styles.message}>
                        If TSYS credentials exist, a transaction key may have been generated by the Location's POS. If
                        a new key is needed, click the button below to generate a new TSYS Transaction Key. This will
                        replace the existing key. If a transaction key does not yet exist, this will create a new key.
                    </span>
                    {this.props.view !== 'show' &&
                    <span style={styles.message}>
                        If the above TSYS credentials are removed or modified, the transaction key will be removed. A
                        new key must be generated by the POS, or a new key may be generated if this Location is saved
                        and then reopened for editing.
                    </span>
                    }
                    <RaisedButton
                        primary
                        label="Generate Transaction Key"
                        icon={<ContentKey/>}
                        onClick={(e) => this.handleButtonClick(e)}
                        disabled={!showComponent || disableButton}
                    />
                    {submitting &&
                    <CircularProgress
                        size={20}
                        thickness={2}
                        style={styles.loader}
                    />
                    }
                </div>
                }
                {showMessageChanged &&
                <span style={styles.message}>
                        The TSYS account credentials have changed. No new transaction key may be generated.
                    </span>
                }
                {showMessageError && message &&
                <span style={{...styles.message, ...styles.error}}>{message}</span>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    if (ownProps.view === 'edit' || ownProps.view === 'create') {
        // For Create/Edit, set the gateway value from the form
        let form = state.form['record-form'];
        if (form && form.values) {
            const gatewayValue = (form.values['gateway_account']) ? form.values['gateway_account'] : {};
            return {
                gateway: gatewayValue
            }
        }
    } else {
        // For Show, set the Gateway and Location value
        if (!ownProps.location && state.routing && state.routing.location) {
            // Retrieve Location ID from route
            const pathname = state.routing.location.pathname;
            let location = null;
            if (pathname) {
                const pathArr = pathname.split('/');
                if (pathArr && pathArr.length > 2) {
                    location = pathArr[2].toString();
                }
            }
            if (location) {
                let data = state.admin.resources[ownProps.resource].data[location];
                let transactionKey = (data && data.gateway_account && data.gateway_account.transaction_key) ? data.gateway_account.transaction_key : null;
                if (data) {
                    return {
                        gateway: data.gateway_account,
                        record: data,
                        location: location,
                        transactionKey: transactionKey,
                    }
                }
            }
        }
    }
    return {}
};

GenerateTSYSTransactionKey.propTypes = {
    addField: PropTypes.bool,
    gateway: PropTypes.object,
    location: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string,
    view: PropTypes.string.isRequired,
};

GenerateTSYSTransactionKey.defaultProps = {
    addField: true,
    gateway: {},
    location: null,
    record: {},
    resource: 'Locations',
    view: 'edit',
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(GenerateTSYSTransactionKey);



// WEBPACK FOOTER //
// ./src/Fuse/components/GenerateTSYSTransactionKey.js